import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_star_outline.svg';
import Icon, { IconProps } from './icon';

const IconStarOutline = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconStarOutline;
